import { useQueryClient } from '@tanstack/react-query'

import {
  usePutAgreedPlacePicture,
  useDeleteAgreedPlacePicture,
  getGetAgreedPlacePictureQueryKey,
} from '@dhl/receiver-preference-api'

type UpdatePhotoProps = {
  photo?: Blob
  previousPhoto?: Blob
}

export const useUpdateAgreedPlacePhoto = (): {
  updateAgreedPlacePhoto: (addressId: string, props: UpdatePhotoProps) => Promise<void>
} => {
  const { mutateAsync: uploadPhoto } = usePutAgreedPlacePicture()
  const { mutateAsync: deletePhoto } = useDeleteAgreedPlacePicture()
  const queryClient = useQueryClient()

  const updateAgreedPlacePhoto = async (
    addressId: string,
    { photo, previousPhoto }: UpdatePhotoProps
  ): Promise<void> => {
    if (photo) {
      await uploadPhoto({ addressId, data: photo })
      queryClient.setQueryData(getGetAgreedPlacePictureQueryKey(addressId), photo)
    } else if (previousPhoto) {
      await deletePhoto({ addressId })
      queryClient.removeQueries({ queryKey: getGetAgreedPlacePictureQueryKey(addressId) })
    }
  }

  return { updateAgreedPlacePhoto }
}
